import { IIconBase } from '..'

const desconsiderarBigIcon = ({
  color = '#664D03',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M37.1673 3.3335L3.83398 36.6668'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.9673 14.5166V32.8499C34.9673 36.1999 32.5673 37.6166 29.634 35.9833L18.834 29.2333'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.0332 33.2502V9.76683C6.0332 6.2335 8.91654 3.3335 12.4665 3.3335H28.5499C30.5665 3.3335 32.3665 4.26683 33.5499 5.7335'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default desconsiderarBigIcon
